export const SET_MOBILE_VIEW = 'SET_MOBILE_VIEW';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const SET_ENLIGHTEN_MANAGER_TOKEN = 'SET_ENLIGHTEN_MANAGER_TOKEN';

export const SET_USER_DETAILS = 'SET_USER_DETAILS';
